import { defaultChainId } from '../constants'
import tokenlist from './tokenlist.json'

const thisChainTokens = tokenlist.tokens.filter((token) => token.chainId === defaultChainId)
const tokenAddresses = thisChainTokens.map((token) => token.address.toLowerCase())

export { tokenlist, tokenAddresses, thisChainTokens }
